
























import moment from 'moment';
import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { LoadingService } from '@/services/loadingService';
import { ServicioProxy } from '@/config/enums'; //
import { Component, Prop } from 'vue-property-decorator';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue'; //
import { TranslateResult } from 'vue-i18n';
import { GridApi } from 'ag-grid-community';
import { consoleSandbox } from '@sentry/utils';
import { asociacionEventBus } from '@/setup';
import FormPowerHowen from './FormPowerHowen.vue';
import FormTimeHowen from './FormTimeHowen.vue';
@Component({
  components: {
    'app-confirmacion': Confirmation,
    FormTimeHowen,
    FormPowerHowen,
  },
})
export default class SysConfigHowen extends Vue {
  @Prop({ default: false }) edited!: any;
  @Prop({ default: false }) esEdicion!: boolean;
  @Prop({ default: {} }) selectedValue: any;
  @Prop({ default: {} }) usuario: any;
  show: boolean = true;
  accion!: any;
  ordesList2: any;
  items: any[] = [
    { index: 0, tab: 'Time', content: 'FormTimeHowen' },
    { index: 1, tab: 'Power', content: 'FormPowerHowen' },
  ];
  tab: any = null;
  onSelectionChanged(params: any) {}
  //abstract
  readonly funcionalidad: Funcionalidades = Funcionalidades.Streamax;
  //propiedades globales
  loadingService = new LoadingService();
  gridApi: GridApi;
  $snotify: any;
  dialog: boolean = true;
  dialogConfirmacionClose: boolean = false;
  bottomNav: any = '1';
  dictionaryFormErrors: any = {};
  validForm: boolean = false;
  dialogConfirmacion: boolean = false;
  btnBloquear: Boolean = false;
  //Interface
  estadoSwitch: boolean = false;
  //controllers
  readonly controller: string = 'funcionalidad';
  readonly controllerAccion: string = 'accion';
  readonly controllerModuloAccion: string = 'moduloaccion';
  axios: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
}
